import styled from 'styled-components'
import { desktopBreakpoint, wideScreenBreakpoint, tabletBreakpoint } from 'react-components'
import { LAYOUT } from '../../../../constants/search-result-listing'
import { getBasePath } from '../../../../utils/miscellaneous-utils'

export const ListSectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;
    min-height: 100vh;
`

export const PageContent = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 1rem;
    gap: 1rem;
    max-width: ${wideScreenBreakpoint.min}px;
    margin: 0 auto;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 1.5rem;
    }
`

export const ColumnsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        flex-direction: row;
    }
`

export const LeftColumn = styled.div`
    display: none;
    flex-direction: column;
    width: ${LAYOUT.SMALL_SIDEBAR_WIDTH}rem;
    flex-shrink: 0;
    gap: 1.5rem;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        display: flex;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        width: ${LAYOUT.SIDEBAR_WIDTH}rem;
    }
`

export const RightColumn = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
`

export const MapWidgetContainer = styled.div`
    position: relative;
    top: 0;
    width: 100%;
    height: 72px;
    border-radius: 12px;
    overflow: hidden;
    background-color: #f7f7f7;
    display: none;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    flex-shrink: 0;
    z-index: 1;

    &:hover {
        opacity: 0.95;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        display: flex;
    }
`

export const MapWidgetBackground = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${getBasePath('/assets/images/srl/map-view.png')});
    background-size: cover;
    background-position: center;
    z-index: 0;
`

export const MapButton = styled.button`
    position: relative;
    z-index: 1;
    background: white;
    padding: 10px 20px;
    border-radius: 0.25rem;
    border: none;

    display: flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }

    svg {
        width: 1.5rem;
        height: 1.5rem;
    }
`

export const MapViewLabel = styled.span`
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    font-size: 0.875rem;
    line-height: 1.5rem;
    color: #282828;
    font-weight: 600;
`

export const FilterHeaderContainer = styled.div`
    z-index: 10;
    background: white;
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        display: none;
    }
`
// Blocking overlay for loading state
export const BlockingOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    backdrop-filter: blur(2px);
`

export const LoaderDots = styled.div`
    display: flex;
    gap: 8px;

    & > span {
        width: 10px;
        height: 10px;
        background-color: #212121;
        border-radius: 50%;
        animation: bounce 1.4s infinite ease-in-out both;
    }

    & > span:nth-child(1) {
        animation-delay: -0.32s;
    }

    & > span:nth-child(2) {
        animation-delay: -0.16s;
    }

    & > span:nth-child(3) {
        animation-delay: 0s;
    }

    @keyframes bounce {
        0%,
        80%,
        100% {
            transform: scale(0);
        }
        40% {
            transform: scale(1);
        }
    }
`

export const ContentWrapper = styled.div`
    position: relative;
`

export const MobileMapButton = styled.button`
    position: fixed;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    background-color: #212121;
    color: white;
    border: none;
    border-radius: 2rem;
    padding: 0 1rem;
    height: 2rem;
    z-index: 100;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease;

    svg {
        width: 20px;
        height: 20px;
        path {
            fill: white;
        }
    }

    /* stylelint-disable-next-line no-descending-specificity */
    & > span {
        color: white;
    }

    font-family: inherit;
    font-weight: 600;
    font-size: 0.875rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        display: none;
    }
`
